const routes = [
  {
    path: '/desktop-message',
    component: () => import('pages/DesktopMessagePage.vue'),
    meta: { requiresAuth: false, isDesktopMessage: true },
  },
  {
    path: '/start',
    component: () => import('layouts/LoginLayout.vue'),
    meta: { guestOnly: true, requiresMobile: true },
    children: [{ path: '', component: () => import('pages/login/StartPage.vue') }],
  },
  {
    path: '/login',
    component: () => import('layouts/LoginLayout.vue'),
    meta: { guestOnly: true, requiresMobile: true },
    children: [{ path: '', component: () => import('pages/login/LoginPage.vue') }],
  },
  {
    path: '/register',
    component: () => import('layouts/LoginLayout.vue'),
    meta: { guestOnly: true, requiresMobile: true },
    children: [{ path: '', component: () => import('pages/login/RegisterPage.vue') }],
  },
  {
    // Callback СберБизнес ID: авторизованный пользователь (верификация компании)
    path: '/sbbid/callback',
    component: () => import('layouts/LoginLayout.vue'),
    meta: { requiresAuth: false, requiresMobile: false },
    children: [{ path: '', component: () => import('pages/login/SbbidCallbackPage.vue') }],
  },
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    meta: { requiresAuth: true, requiresMobile: true },
    children: [
      { path: '', name: 'main', component: () => import('pages/ProfilePage.vue') },
      { path: 'profile-edit', component: () => import('pages/ProfileEditPage.vue') },
      {
        path: 'profile-edit',
        component: () => import('pages/ProfileEditPage.vue'),
      },
      { path: 'profile', component: () => import('pages/ProfilePage.vue') },
      { path: 'company-profile', component: () => import('pages/CompanyPage.vue') },
      { path: 'company-edit', component: () => import('pages/CompanyEditPage.vue') },
      { path: 'departments', component: () => import('pages/DepartmentsPage.vue') },
      { path: 'posts', component: () => import('pages/PostsPage.vue') },
      { path: 'employees', component: () => import('pages/EmployeeListPage.vue') },
      {
        path: 'employee-edit/:id',
        props: true,
        component: () => import('pages/EmployeeEditPage.vue'),
      },
      { path: 'events', component: () => import('pages/CompanyEventsPage.vue') },
      { path: 'contact/:contactId', props: true, component: () => import('pages/ContactPage.vue') },
      {
        path: 'company-contact-card/:contactId',
        props: true,
        component: () => import('pages/CompanyContactCardPage.vue'),
      },
      { path: 'settings', props: true, component: () => import('pages/SettingsPage.vue') },
      {
        path: 'subscription',
        name: 'subscription',
        component: () => import('pages/SubscriptionPage.vue'),
      },
      { path: 'order/:orderId', props: true, component: () => import('pages/OrderPage.vue') },
      { path: 'contacts', component: () => import('pages/ContactListPage.vue') },
      { path: 'calendar', component: () => import('pages/CalendarPage.vue') },
      {
        path: 'meeting/:id',
        props: true,
        component: () => import('pages/MeetingPage.vue'),
      },
    ],
  },
  {
    path: '/vcard/:trackId',
    component: () => import('layouts/LayoutSwitcher.vue'),
    meta: { requiresAuth: false, requiresMobile: true },
    children: [
      {
        path: '',
        props: true,
        component: () => import('pages/public/vCardPage.vue'),
      },
    ],
  },
  {
    path: '/',
    component: () => import('layouts/LayoutSwitcher.vue'),
    meta: { requiresAuth: false, requiresMobile: true },
    children: [
      {
        path: 'company-card/:trackId',
        props: true,
        component: () => import('pages/public/CompanyCardPage.vue'),
      },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
]

export default routes
